import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <UpdatesSection />
        <RankingSection />
        <TopicsSection />
        <ContactSection />
        <MediaSection />
        <FeaturesSection />
        <CardsSection />
        <CommentsSection />
        <IndexSection />
        <FaqSection />
        <AppSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}